module.exports = __webpack_public_path__ + "static/media/DiamondsWowpot.559b44d1.png";